import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { NebulaPlugin } from './nebula-plugin';
export var NebulaUpTracePlugin = function (_NebulaPlugin) {
    _inherits(NebulaUpTracePlugin, _NebulaPlugin);

    function NebulaUpTracePlugin() {
        _classCallCheck(this, NebulaUpTracePlugin);

        return _possibleConstructorReturn(this, (NebulaUpTracePlugin.__proto__ || Object.getPrototypeOf(NebulaUpTracePlugin)).apply(this, arguments));
    }

    _createClass(NebulaUpTracePlugin, [{
        key: 'reportSelfPageChange',
        value: function reportSelfPageChange(param, callback) {
            window.AlipayJSBridge.call('reportSelfPageChange', {
                type: param.type,
                selfPageUrl: param.selfPageUrl,
                selfPageTitle: param.selfPageTitle
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'reportPageClickEvent',
        value: function reportPageClickEvent(param, callback) {
            window.AlipayJSBridge.call('reportPageClickEvent', {
                actionCode: param.actionCode,
                dataType: param.dataType || '',
                extentInfo: param.extentInfo,
                url: param.url || null
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'statPageEventData',
        value: function statPageEventData(param, callback) {
            var _a;
            var newPageName = (_a = param.pageName) !== null && _a !== void 0 ? _a : '';
            window.AlipayJSBridge.call('statPageEventData', {
                pageName: newPageName,
                tagName: param.tagName,
                timeStamp: param.timeStamp
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'reportTraceEvent',
        value: function reportTraceEvent(param, callback) {
            window.AlipayJSBridge.call('h5TraceEvent', {
                eventId: param.eventId,
                attributes: param.attributes
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'reportPageExposureEvent',
        value: function reportPageExposureEvent(param, callback) {
            window.AlipayJSBridge.call('reportPageExposureEvent', param, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'savePageCommonEvent',
        value: function savePageCommonEvent(param, callback) {
            window.AlipayJSBridge.call('savePageCommonEvent', param, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'gioTrack',
        value: function gioTrack(param, callback) {
            window.AlipayJSBridge.call('gioTrack', param, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'gioTrackWithVariable',
        value: function gioTrackWithVariable(param, callback) {
            window.AlipayJSBridge.call('gioTrackWithVariable', param, this.generateCallbackFunc(callback));
        }
    }]);

    return NebulaUpTracePlugin;
}(NebulaPlugin);